import { Country, Postcode } from '@dreryk/address-common-api';

import { FormContextValues, useTranslate } from '@dreryk/react-common';

import { patientTranslationKeys } from '../../../../translations';
import { CountryField } from '../../../ContactDetailsForm/CountryField';
import { EmailAddressField } from '../../../ContactDetailsForm/EmailAddressField';
import { PhoneNumberField } from '../../../ContactDetailsForm/PhoneNumberField';
import { PostalCodeField } from '../../../ContactDetailsForm/PostalCodeField';
import { FlatField } from '../../../FlatField';
import { FormSectionHeader } from '../../../FormSectionHeader';
import { HouseField } from '../../../HouseField';
import { StreetField } from '../../../StreetField';
import { StyledFormSection } from '../../../StyledFormSection';
import { StyledNarrowInput } from '../../../StyledNarrowInput';
import { TownField } from '../../../TownField';

type AddressFormBeanPart = {
   flat: string | null;
   country: Country;
   town: string | null;
   postcode: Postcode | null;
   street: string | null;
   house: string | null;
};

type ContactDetailsAccordionSectionProps = Pick<FormContextValues<AddressFormBeanPart>, 'watch' | 'register'> & {
   readonly statutoryRepresentative: boolean;
};

export const ContactDetailsSection = (props: ContactDetailsAccordionSectionProps): JSX.Element => {
   const translate = useTranslate();
   return (
      <div>
         <FormSectionHeader>{translate(patientTranslationKeys.addressAndContactDetails)}</FormSectionHeader>
         <StyledFormSection testId={'contactDetails'}>
            <CountryField register={props.register} required={props.statutoryRepresentative} />
            <TownField name={'town'} register={props.register} required={props.statutoryRepresentative} />
            <PostalCodeField register={props.register} watch={props.watch} required={props.statutoryRepresentative} />
            <StreetField name={'street'} register={props.register} required={props.statutoryRepresentative} />
            <StyledNarrowInput>
               <HouseField name={'house'} register={props.register} required={props.statutoryRepresentative} />
            </StyledNarrowInput>
            <StyledNarrowInput>
               <FlatField name={'flat'} register={props.register} />
            </StyledNarrowInput>
            <PhoneNumberField register={props.register} />
            <EmailAddressField register={props.register} />
         </StyledFormSection>
      </div>
   );
};
